var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.offer.parts, function(part, partIndex) {
      return _c(
        "v-row",
        { key: partIndex },
        [
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.carRental"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.name,
                  callback: function($$v) {
                    _vm.$set(part, "name", $$v)
                  },
                  expression: "part.name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.pickupDate"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.start_date,
                  callback: function($$v) {
                    _vm.$set(part, "start_date", $$v)
                  },
                  expression: "part.start_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.returnCarDate"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.end_date,
                  callback: function($$v) {
                    _vm.$set(part, "end_date", $$v)
                  },
                  expression: "part.end_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.carClass"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.car_class,
                  callback: function($$v) {
                    _vm.$set(part, "car_class", $$v)
                  },
                  expression: "part.car_class"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.pickupPlace"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.from,
                  callback: function($$v) {
                    _vm.$set(part, "from", $$v)
                  },
                  expression: "part.from"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.returnCarPlace"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.to,
                  callback: function($$v) {
                    _vm.$set(part, "to", $$v)
                  },
                  expression: "part.to"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.averagePricePerDay"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.price_per_day,
                  callback: function($$v) {
                    _vm.$set(part, "price_per_day", $$v)
                  },
                  expression: "part.price_per_day"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: _vm.$t("travelService.travelAgentComment"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.comment,
                  callback: function($$v) {
                    _vm.$set(part, "comment", $$v)
                  },
                  expression: "part.comment"
                }
              })
            ],
            1
          ),
          partIndex < _vm.offer.parts.length - 1
            ? _c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }